import React from 'react';
import PropTypes from 'prop-types';
import { Div } from '../index';

export default function LabelControl({ props, children, customClass, reference }) {
    return (
        <Div
            className={'LabelControl ' + (customClass ? customClass : '')}
            ref={reference}
            {...props}
        >
            {children}
        </Div>
    );
}

LabelControl.propTypes = {
    children: PropTypes.any,
    customClass: PropTypes.string,
    reference: PropTypes.object,
    props: PropTypes.object,
};
